import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import {
  corporateMasterKanpoNoticesApiPath,
  getCorporateKanpoNotices,
} from "../api";
import { inlineErrorSwrOptions } from "./inlineErrorSwrOptions";
import type { KanpoNoticeListResponse } from "../types";

/**
 * 法人マスタに紐づいた官報の公告を取得する（GET corporate-master/<法人番号>/kanpo-notices）。
 * 13桁の半角数字の法人番号のときのみ取得する
 * @param corporateNumber 法人番号（13桁）
 * @returns SWRレスポンス（count は件数、list は公告日の新しい順）
 */
export const useCorporateKanpoNotices = (
  corporateNumber: string
): SWRResponse<KanpoNoticeListResponse, Error> => {
  const { apiClient } = useApiClient();
  return useSWR<KanpoNoticeListResponse, Error>(
    /^\d{13}$/.test(corporateNumber)
      ? corporateMasterKanpoNoticesApiPath(corporateNumber)
      : null,
    async () => await getCorporateKanpoNotices(apiClient, corporateNumber),
    {
      revalidateOnFocus: false,
      ...inlineErrorSwrOptions,
    }
  );
};
